import { render, staticRenderFns } from "./InitialFrame.vue?vue&type=template&id=2480a8a4"
import script from "./InitialFrame.vue?vue&type=script&lang=js"
export * from "./InitialFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports